import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO } from "@/lib/constants";

export const LegalPage = ({ title, updated, hideNote, children }) => (
  <main className="relative mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24" data-testid="legal-page">
    <Link to="/" className="mb-10 inline-flex items-center gap-2 text-sm text-navy-soft hover:text-lavender-deep transition-colors">
      <ArrowLeft size={16} /> Torna al sito
    </Link>
    <img src={LOGO} alt="Cosplay Singers" className="mb-6 h-16 w-16 object-contain" />
    <h1 className="font-serif tracking-tightest text-4xl sm:text-5xl text-navy">{title}</h1>
    {updated && <p className="mt-3 text-sm text-navy-faint">Ultimo aggiornamento: {updated}</p>}
    <div className="prose-legal mt-10 space-y-6 text-navy-soft leading-relaxed [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-navy [&_h2]:mt-10 [&_a]:text-lavender-deep [&_a]:underline">
      {children}
    </div>
    {!hideNote && (
      <p className="mt-14 rounded-2xl glass p-4 text-xs text-navy-faint">
        Nota: questo è un testo informativo provvisorio, non un documento legale definitivo. L’informativa completa verrà pubblicata a breve.
      </p>
    )}
  </main>
);
